import { IKeHoachGhepLopRequest } from "../../model/request/ke-hoach/IKeHoachGhepLopRequest";
import { apiClient } from "../apiClient";

export const KE_HOACH_MON_PHAM_VI_ENDPOINT = "ke-hoach-mon-pham-vi";

export const keHoachPhamViApi = {
    Saves: (request: IKeHoachGhepLopRequest) => apiClient.post(`${KE_HOACH_MON_PHAM_VI_ENDPOINT}`, request),
    Delete: (id: number) => apiClient.delete(`${KE_HOACH_MON_PHAM_VI_ENDPOINT}/{id}`),
};
